// Internationalization (i18n) utility
const translations = {
  sr: {
    nav: {
      login: 'Prijava',
      register: 'Registracija',
      startFree: 'Počni besplatno',
      theme: 'Tema',
      language: 'Jezik',
      calendar: 'Kalendar',
      payments: 'Plaćanja',
      jobs: 'Oglasi',
      profile: 'Profil',
      notifications: 'Notifikacije',
      friends: 'Prijatelji',
      conversations: 'Poruke',
      logout: 'Odjavi se',
      settings: 'Podešavanja',
      accountMenu: 'Meni naloga',
    },
    landing: {
      header: {
        badge: 'Babysitter Tracker',
        login: 'Uloguj se',
        register: 'Registruj se',
      },
      hero: {
        eyebrow: 'Za roditelje i dadilje',
        title: 'Mreža poverenja za porodice i negovatelje',
        descriptionShort: 'Pronađite dadilju, dogovorite termine i vodite evidenciju aktivnosti na jednom mestu.',
        imageAlt: 'Roditelj čita knjigu sa decom u svetloj dnevnoj sobi',
        badgeVerified: 'Proveren profil',
        register: 'Registruj se besplatno',
        login: 'Prijavi se',
      },
      search: {
        findSitter: 'Tražim dadilju',
        findJob: 'Tražim posao',
        placeholder: 'Unesite grad ili naselje…',
        submitSitter: 'Pronađi dadilju',
        submitJob: 'Pronađi posao',
      },
      trust: {
        verified: 'Provereni profili',
        reviews: 'Ocene roditelja',
        tracking: 'Praćenje termina',
        payment: 'Sigurno plaćanje',
      },
      howItWorks: {
        title: 'Kako funkcioniše',
        subtitle: 'Tri jednostavna koraka do pouzdane pomoći.',
        step1: {
          title: 'Pretražite profile',
          desc: 'Pronađite dadilje u svom gradu i pregledajte profile i ocene.',
          imageAlt: 'Roditelj pretražuje profile na telefonu',
        },
        step2: {
          title: 'Dogovorite termin',
          desc: 'Uskladite dostupnost i uslove, pa mirno dogovorite čuvanje.',
          imageAlt: 'Roditelj i dete u toplom trenutku kod kuće',
        },
        step3: {
          title: 'Pratite aktivnosti',
          desc: 'Vodite evidenciju termina i dogovora na jednom mestu.',
          imageAlt: 'Dadilja crta sa detetom za stolom',
        },
      },
      benefits: {
        sectionTitle: 'Jedna platforma, dve jasne potrebe',
        parents: {
          title: 'Za roditelje',
          cardTitle: 'Lakše pronađite osobu kojoj možete da verujete',
          description: 'Pregledajte profile, dogovorite termine i pratite aktivnosti bez poruka razbacanih na sve strane.',
          imageAlt: 'Roditelj i dete u toplom kućnom trenutku',
          item1: 'Provereni profili i preporuke',
          item2: 'Jednostavnije dogovaranje termina',
          item3: 'Pregled aktivnosti na jednom mestu',
          cta: 'Pronađi dadilju',
        },
        sitters: {
          title: 'Za dadilje',
          cardTitle: 'Predstavite iskustvo profesionalno',
          description: 'Napravite profil, organizujte angažmane i lakše komunicirajte sa porodicama.',
          imageAlt: 'Dadilja i dete u zajedničkoj aktivnosti',
          item1: 'Profesionalan profil',
          item2: 'Jasna evidencija angažmana',
          item3: 'Lakši dolazak do novih poslova',
          cta: 'Registruj se kao dadilja',
        },
      },
      features: {
        title: 'Manje haosa u dogovorima, više jasnih termina',
        subtitle: 'Nannity pomaže roditeljima i dadiljama da dogovori, termini, aktivnosti i obaveze budu pregledni na jednom mestu.',
        imageAlt: 'Porodica i dadilja u toplom kućnom ambijentu',
        profiles: {
          title: 'Profili i preporuke',
          description: 'Pregledajte iskustvo, preporuke i osnovne informacije pre dogovora.',
        },
        schedule: {
          title: 'Termini i aktivnosti',
          description: 'Dogovoreni termini i planirane aktivnosti su jasno organizovani.',
        },
        hours: {
          title: 'Evidencija sati',
          description: 'Lakše pratite provedeno vreme i dogovorene obaveze.',
        },
        payments: {
          title: 'Plaćanja i podsetnici',
          description: 'Manje zaboravljanja i manje ručnog računanja.',
        },
      },
      testimonials: {
        title: 'Poverenje se gradi kroz svakodnevne dogovore',
        subtitle: 'Kratka iskustva roditelja i dadilja koji žele jasniju organizaciju čuvanja.',
        t1: {
          name: 'Marko P.',
          role: 'roditelj',
          text: 'Najviše mi znači što termine, dogovore i aktivnosti ne tražim po porukama, već imam pregled na jednom mestu.',
        },
        t2: {
          name: 'Jovana S.',
          role: 'roditelj',
          text: 'Lakše pratim šta je dogovoreno za svako čuvanje i imam jasniji pregled obaveza.',
        },
        t3: {
          name: 'Ana M.',
          role: 'dadilja',
          text: 'Profil mi pomaže da profesionalnije predstavim iskustvo porodicama.',
        },
      },
      pricing: {
        title: 'Cene i Planovi',
        description: 'Odaberi plan koji ti najbolje odgovara. Svi planovi uključuju osnovne funkcije.',
        free: 'Besplatan',
        basic: 'Osnovni',
        premium: 'Premium',
        month: 'RSD/mesec',
        mostPopular: 'Najpopularniji',
        select: 'Odaberi',
      },
      cta: {
        title: 'Spremni da počnete?',
        description: 'Pridružite se roditeljima i dadiljama koji koriste Nannity za jednostavniju organizaciju čuvanja.',
      },
      faq: {
        title: 'Često postavljana pitanja',
        q1: 'Kako funkcioniše Nannity?',
        a1: 'Nannity je platforma koja povezuje roditelje i dadilje. Roditelji mogu da prate sate rada, automatski izračunavaju plaćanja i upravljaju kalendarom. Dadilje mogu da prate svoje poslove, zaradu i primaju notifikacije o novim prilikama.',
        q2: 'Da li je platforma besplatna?',
        a2: 'Da, postoji besplatan plan sa osnovnim funkcijama. Takođe imamo Osnovni plan (599 RSD/mesec) i Premium plan (899 RSD/mesec) sa dodatnim mogućnostima.',
        q3: 'Kako funkcioniše automatsko plaćanje?',
        a3: 'Možete podesiti dinamiku plaćanja (mesečno, nedeljno, ili po određenim danima). Platforma automatski izračunava iznos na osnovu sati rada i satnice, a vi dobijate podsetnike pre datuma plaćanja.',
        q5: 'Mogu li da podelim kalendar sa porodicom?',
        a5: 'Da! Možete podeliti kalendar, plaćanja i veze sa bebisiterkama sa članovima porodice. Samo izaberite šta želite da podelite kada delite kalendar sa prijateljem.',
        q6: 'Kako da počnem?',
        a6: 'Jednostavno se registrujte besplatno, popunite svoj profil i počnite da koristite platformu. Možete odmah da dodate bebisiterku ili da počnete da tražite posao kao dadilja.',
      },
    },
    common: {
      loading: 'Učitavanje...',
      error: 'Greška',
      success: 'Uspešno',
      close: 'Zatvori',
      save: 'Sačuvaj',
      cancel: 'Otkaži',
      add: 'Dodaj',
      delete: 'Obriši',
      edit: 'Izmeni',
      back: 'Nazad',
      yes: 'Da',
      no: 'Ne',
      confirm: 'Potvrdi',
    },
    auth: {
      logoutConfirmTitle: 'Potvrda odjave',
      logoutConfirmMessage: 'Da li ste sigurni da želite da se odjavite?',
      logout: 'Odjavi se',
      login: {
        title: 'Prijavite se',
        subtitle: {
          choose: 'Izaberite način prijave',
          email: 'Unesite vašu email adresu',
          otp: 'Unesite OTP kod sa vašeg email-a',
        },
        emailButton: 'Prijavite se sa emailom',
        googleButton: 'Prijavite se sa Google nalogom',
        or: 'Ili',
        otherMethods: 'Drugi načini prijave',
        continueWithOTP: 'Nastavi sa jednokratnim kodom',
        emailLabel: 'Email adresa',
        emailPlaceholder: 'vas@email.com',
        sendLink: 'Pošalji link na email',
        sending: 'Slanje...',
        sendOTP: 'Pošalji jednokratni kod',
        sendingOTP: 'Slanje OTP koda...',
        otpLabel: 'OTP kod',
        otpPlaceholder: '123456',
        otpSentTo: 'Kod je poslat na:',
        verifyOTP: 'Potvrdi OTP kod',
        verifying: 'Verifikacija...',
        backToEmail: 'Nazad na email',
        noAccount: 'Nemate nalog? Registrujte se',
        checkEmail: 'Proverite email za link za prijavu!',
        loginSuccess: 'Uspešno ste prijavljeni!',
        googleNotConfigured: 'Google Sign In nije konfigurisan. Molimo koristite email link za prijavu.',
        googleNotAvailable: 'Google Sign In nije dostupan na ovom pretraživaču. Molimo koristite email link.',
        googleRequiresHTTPS: 'Google Sign In zahteva HTTPS. Molimo koristite email link za prijavu.',
        googleError: 'Greška pri Google prijavi',
        enterEmail: 'Molimo unesite email adresu',
        enterValidOTP: 'Molimo unesite validan 6-cifreni kod',
        otpSent: 'OTP kod je poslat na vašu email adresu',
        otpError: 'Greška pri slanju OTP koda',
        verifyError: 'Greška pri verifikaciji OTP koda',
        linkError: 'Greška pri slanju linka',
        unknownError: 'Nepoznata greška. Molimo pokušajte ponovo.',
        invalidLink: 'Nevalidan ili istekao login link.',
        verificationError: 'Greška pri verifikaciji. Molimo pokušajte ponovo.',
        invalidLinkRetry: 'Nevalidan login link. Molimo pokušajte ponovo.',
        passwordLabel: 'Lozinka',
        passwordPlaceholder: '••••••••',
        signIn: 'Prijavi se',
        loggingIn: 'Prijava...',
        invalidCredentials: 'Pogrešan email ili lozinka',
        withPassword: 'Prijava sa emailom i lozinkom',
        withOTP: 'Prijava bez lozinke (kod na email)',
        withLink: 'Prijava putem linka na email',
        enterEmailAndPassword: 'Unesite email i lozinku',
        switchToLink: 'Prijava putem linka na email',
        invalidLinkCheckEmail: 'Nevalidan login link. Proverite email ponovo.',
        processingError: 'Greška pri obradi login linka. Molimo pokušajte ponovo.',
        redirecting: 'Uspešno ste prijavljeni! Preusmeravanje...',
        redirectingError: 'Greška pri prijavi. Preusmeravanje na login...',
      },
      register: {
        step: 'Korak',
        of: 'od',
        back: 'Nazad',
        next: 'Dalje',
        role: {
          title: 'Izaberite vašu ulogu',
          parent: {
            title: 'Roditelj / Staratelj',
            description: 'Tražite dadilju za vaše dete',
          },
          babysitter: {
            title: 'Dadilja / Babysitter',
            description: 'Tražite posao kao dadilja',
          },
        },
        seeking: {
          title: 'Tražite li dadilju?',
          description: 'Izaberite opciju ispod',
          yes: 'Da, tražim dadilju',
          no: 'Ne, samo koristim aplikaciju za praćenje',
        },
        jobSearch: {
          title: 'Tražite li posao?',
          fullTime: 'Tražim posao (puno radno vreme)',
          additional: 'Tražim dodatni posao',
          notLooking: 'Ne tražim posao trenutno',
        },
        city: {
          titleProvider: 'U kojim gradovima radite?',
          titleParent: 'U kojim gradovima tražite dadilju?',
          descriptionProvider: 'Možete izabrati gradove u kojima želite da radite',
          descriptionParent: 'Možete izabrati gradove u kojima tražite dadilju',
          addPlaceholder: 'Dodaj drugi grad...',
          addButton: 'Dodaj +',
          alreadyAdded: 'Grad je već dodat',
          enterCity: 'Molimo unesite naziv grada',
          selectAtLeastOne: 'Molimo izaberite bar jedan grad',
        },
        childYear: {
          title: 'Godina rođenja deteta',
          description: 'Izaberite godinu rođenja deteta',
          select: 'Izaberite godinu...',
        },
        hourly: {
          title: 'Vaša satnica',
          description: 'Unesite vašu satnicu u RSD',
          min: 'Min (RSD)',
          max: 'Max (RSD)',
          minPlaceholder: '500',
          maxPlaceholder: '1000',
        },
        name: {
          title: 'Ime i prezime',
          description: 'Unesite vaše ime i prezime',
          firstName: 'Vaše ime',
          lastName: 'Vaše prezime',
        },
        email: {
          title: 'Email i telefon',
          description: 'Unesite email i broj telefona',
          emailPlaceholder: 'Email adresa',
          phonePlaceholder: 'Broj telefona',
        },
        submit: {
          sending: 'Slanje...',
          register: 'Registruj se',
        },
        googleSignUp: 'Registrujte se sa Google nalogom',
        googleComingSoon: 'Registrujte se za nekoliko sekundi koristeći svoj Google nalog.',
        alreadyHaveAccount: 'Već imate nalog? Prijavite se',
        signInLink: 'Prijavite se',
        checkEmail: 'Proverite email za link za registraciju!',
        selectRole: 'Molimo izaberite ulogu',
        selectJobStatus: 'Molimo izaberite status traženja posla',
      },
      completeProfile: {
        title: 'Dovršite profil',
        subtitle: 'Molimo unesite osnovne informacije kako bismo personalizovali vaše iskustvo i omogućili rezervacije.',
        firstName: 'Ime',
        lastName: 'Prezime',
        phone: 'Broj telefona',
        role: 'Uloga',
        roleParent: 'Roditelj / Staratelj',
        roleBabysitter: 'Dadilja / Babysitter',
        hourlyRate: 'Satnica (RSD)',
        street: 'Ulica i broj',
        streetPlaceholder: 'Bulevar Oslobođenja 12',
        city: 'Grad',
        cityPlaceholder: 'Beograd',
        postalCode: 'Poštanski broj',
        postalPlaceholder: '11000',
        info: 'Ove informacije su obavezne kako bi babysitteri i roditelji mogli da vam pošalju ponude i rezervacije.',
        save: 'Sačuvaj profil',
        saving: 'Čuvanje...',
        success: 'Profil je uspešno ažuriran!',
        error: 'Greška pri čuvanju profila. Molimo pokušajte ponovo.',
        validationError: 'Molimo popunite sva obavezna polja.',
        sessionExpired: 'Sesija je istekla. Molimo prijavite se ponovo.',
        photoError: 'Greška pri obradi slike',
        photoTooLarge: 'Fotografija je prevelika. Maksimalna veličina je 5MB.',
      },
    },
    calendar: {
      title: 'Kalendar',
      currentDebt: 'Trenutno dugovanje',
      monthJobs: 'Poslovi ovog meseca',
      workingDays: 'Radnih dana ovog meseca',
      monthlyDebt: 'Dugovanje za ovaj mesec',
      hourlyRate: 'Cena radnog sata (RSD/h)',
      hourlyRatePlaceholder: 'Unesite cenu radnog sata...',
      default: 'Podrazumevano',
      useDefault: 'Koristi podrazumevano',
      selectedBabysitter: 'Izabrana bebisiterka',
      selectedFamily: 'Izabrana porodica',
      selectPerson: 'Izaberite...',
      estimatedAmount: 'Procenjena cena',
      flexibleRates: 'Fleksibilne cene',
      weekdayDaytime: 'Radni dani 9-17h',
      weekdayEvening: 'Radni dani posle 17h i noću',
      weekend: 'Vikend',
      realized: 'Realizovano',
      total: 'Ukupno',
      debtForMonth: 'Dugovanje za',
      paid: 'Plaćeno',
      unpaid: 'Neplaćeno',
      emptyEntry: 'Prazan unos',
      partiallyPaid: 'Delimično plaćeno',
      totalDebt: 'Ukupno dugovanje',
      noPreviousDebt: 'Nema prethodnog dugovanja',
      nextPayment: 'Sledeće plaćanje',
      day: 'dan',
      today: 'Danas',
      noSchedule: 'Nije podešeno',
      setupPayment: 'Podesi plaćanja',
      selectBabysitter: 'Izaberite bebisiterku',
      sharedWith: 'Kalendar podeljen sa',
      sharedWithShort: 'Podeljeno sa',
      sharedBy: 'Podeljeno od',
      calendarView: 'Kalendar',
      listView: 'Lista',
      viewMode: 'Prikaz kalendara',
      calendarActions: 'Akcije nad kalendarom',
      daysForMonth: 'Dani za',
      noBabysitter: 'Trenutno nemate unetu bebisiterku.',
      clickToAdd: 'Kliknite ovde za unos',
      totalHours: 'Ukupno sati',
      jobsForDate: 'Poslovi za',
      job: 'Posao',
      entries: 'Unosi',
      noEntries: 'Nema unosa ovog meseca',
      editEntry: 'Izmeni unos',
      startTime: 'Vreme početka',
      endTime: 'Vreme završetka',
      notes: 'Napomene',
      notesPlaceholder: 'Dodaj napomene...',
      january: 'Januar',
      february: 'Februar',
      march: 'Mart',
      april: 'April',
      may: 'Maj',
      june: 'Jun',
      july: 'Jul',
      august: 'Avgust',
      september: 'Septembar',
      october: 'Oktobar',
      november: 'Novembar',
      december: 'Decembar',
      sunday: 'Ned',
      monday: 'Pon',
      tuesday: 'Uto',
      wednesday: 'Sre',
      thursday: 'Čet',
      friday: 'Pet',
      saturday: 'Sub',
      addEntry: 'Dodaj unos',
      edit: 'Izmeni',
      delete: 'Obriši',
      deleteConfirm: 'Da li ste sigurni da želite da obrišete ovaj unos?',
      saveAndAddAnother: 'Sačuvaj i dodaj još jedan',
      subtitle: 'Upravljajte svojim smenama i satnicama',
      manageSchedule: 'Organizujte raspored rada u nekoliko klikova',
      selectedDay: 'Izabrani dan',
      addTimeSlot: 'Unesi vreme',
      noEntriesDay: 'Nema unosa za ovaj dan',
      timeSlots: 'termina',
      monthOverview: 'Pregled meseca',
      shareWithFriend: 'Podeli kalendar sa prijateljem',
      overlapError: 'Vremenski period se preklapa sa postojećim unosom.',
      invalidRange: 'Vreme početka mora biti pre vremena završetka.',
      noRateSet: 'Cena nije postavljena',
      updateError: 'Greška pri ažuriranju unosa',
      createError: 'Greška pri kreiranju unosa',
      deleteError: 'Greška pri brisanju unosa',
      deleteSuccess: 'Unos je uspešno obrisan.',
      deleteConfirmTitle: 'Potvrda brisanja',
      paymentDue: 'Plaćanje dospeva',
      autoFillFullTime: 'Auto puno radno vreme',
      paymentCompleted: 'Plaćanje izvršeno',
      days: 'dana',
      markAsUnpaid: 'Označi kao neplaćeno',
      noEntriesToMark: 'Nema unosa za ovaj dan',
      dayMarkedAsPaid: 'Dan je označen kao plaćen',
      markPaidError: 'Greška pri označavanju dana kao plaćenog',
      dayMarkedAsUnpaid: 'Dan je označen kao neplaćen',
      markUnpaidError: 'Greška pri označavanju dana kao neplaćenog',
      manageBabysitters: 'Upravljaj bebisiterkama',
      setPaymentDate: 'Postavi datum plaćanja',
      paymentDate: 'Datum plaćanja',
      paymentDateHint: 'Ostavite prazno da uklonite ručno postavljen datum plaćanja.',
      paymentDateRequired: 'Molimo unesite datum plaćanja.',
      paymentDateSet: 'Datum plaćanja je postavljen.',
      paymentDateError: 'Greška pri postavljanju datuma plaćanja.',
      paymentDateRemoved: 'Datum plaćanja je uklonjen.',
      removePaymentDate: 'Ukloni datum plaćanja',
      manualPaymentDate: 'Ručni datum plaćanja',
      paymentTime: 'Vreme plaćanja',
      paymentTimeHint: 'Podrazumevano vreme je 14:00',
      paymentDateConfirm: 'Da li želite da postavite datum plaćanja za ovaj dan?',
      confirmPaymentDate: 'Potvrdi',
      markAsPaid: 'Označi kao plaćeno',
      recordPaymentUpToDate: 'Izmiri sva dugovanja do datuma',
      recordPaymentModalTitle: 'Zabeleži uplatu',
      markDayRowAsPaid: 'Označi dan kao plaćen',
      markDayRowAsUnpaid: 'Označi dan kao neplaćen',
      markDayRowAsPaidShort: 'Plaćeno',
      markDayRowAsUnpaidShort: 'Neplaćeno',
      editingSharedCalendarHint: 'Uređujete deljeni kalendar (imate dozvolu za pisanje).',
      history: 'Istorija',
      someone: 'Neko',
      auditEntryCreated: 'Unos kreiran',
      auditEntryUpdated: 'Unos izmenjen',
      auditEntryDeleted: 'Unos obrisan',
      auditEntryMarkedPaid: 'Dan označen kao plaćen',
      auditEntryMarkedUnpaid: 'Dan označen kao neplaćen',
      auditPaymentDateSet: 'Datum plaćanja postavljen',
      auditPaymentDateRemoved: 'Datum plaćanja uklonjen',
      auditUnknown: 'Izmena',
      markAsPaidConfirm: 'Označite dan kao plaćen i kreirajte zapis o plaćanju.',
      markAsPaidHint: 'Iznos obuhvata sve neplaćene unose do ovog datuma (uključujući ranije mesece). Možete ga izmeniti.',
      confirmMarkAsPaid: 'Potvrdi i označi kao plaćeno',
      paymentMarkedAsPaid: 'Plaćanje je označeno kao plaćeno i kreiran je zapis.',
      invalidAmount: 'Unesite validan iznos.',
      amount: 'Iznos (RSD)',
      amountHint: 'Predloženi iznos na osnovu unosa do datuma plaćanja',
      autoFillOptions: 'Automatsko popunjavanje kalendara',
      autoFillToToday: 'Popuni do današnjeg dana',
      autoFillToSelected: 'Popuni do označenog datuma',
      autoFillToSelectedSuccess: 'Kreirano {count} unosa do označenog datuma.',
      autoFillMonth: 'Popuni za ceo mesec',
      autoFillSuccess: 'Kreirano {count} unosa do današnjeg dana.',
      autoFillMonthSuccess: 'Kreirano {count} unosa za ceo mesec.',
      autoFillError: 'Greška pri automatskom popunjavanju',
      deleteAllMonth: 'Ukloni sva vremena za ovaj mesec',
      deleteAllMonthConfirm: 'Da li ste sigurni da želite da obrišete sva vremena za ovaj mesec?',
      deleteAllMonthConfirmTitle: 'Potvrda brisanja',
      deleteAllMonthSuccess: 'Obrisano {count} unosa za ovaj mesec.',
      deleteAllMonthError: 'Greška pri brisanju unosa',
      totalHoursThisMonth: 'Ukupno sati ovaj mesec',
      unpaidHoursThisMonth: 'Neplaćeno za ovaj mesec',
      markAllPaidToToday: 'Označi sve kao plaćeno do danas',
      markAllPaidToTodaySuccess: 'Označeno {count} unosa kao plaćeno do danas.',
      markAllPaidToSelected: 'Označi sve kao plaćeno do datuma',
      markAllPaidToSelectedSuccess: 'Označeno {count} unosa kao plaćeno do datuma.',
      markAllPaidMonth: 'Označi sve kao plaćeno za mesec',
      markAllPaidMonthSuccess: 'Označeno {count} unosa kao plaćeno za mesec.',
      markAllPaidError: 'Greška pri označavanju kao plaćeno',
      setPaymentDates: 'Postavi datume plaćanja prema dinamici',
      setPaymentDatesSuccess: 'Postavljeno {count} datuma plaćanja prema dinamici.',
      setPaymentDatesError: 'Greška pri postavljanju datuma plaćanja',
      noPaymentSchedule: 'Nema postavljene dinamike plaćanja za bebisiterku.',
    },
    payments: {
      title: 'Plaćanja',
      currentCharge: 'Trenutno dugovanje',
      nextPayDay: 'Sledeći dan plaćanja',
      manualPayDay: 'Ručno postavljen datum plaćanja',
      inDays: 'za',
      days: 'dana',
      paymentPeriod: 'Period plaćanja',
      periodStart: 'Datum početka',
      periodEnd: 'Datum završetka',
      unpaidPeriod: 'Neplaćeni period',
      unpaidPeriods: 'Neplaćeno:',
      toBabysitter: 'Za',
      noBabysitter: 'Nemate unetu bebisiterku. Dodajte bebisiterku sa stranice Prijatelji.',
      noPaymentSchedule: 'Nije podešena dinamika plaćanja. Podesite dinamiku plaćanja za bebisiterku.',
      firstDueSection: 'Prvi deo dospeva',
      previousPayments: 'Prethodna plaćanja',
      noPayments: 'Nema prethodnih plaćanja',
      payment: 'Plaćanje',
      paid: 'Plaćeno',
      addPayment: 'Dodaj plaćanje',
      paymentHistory: 'Istorija plaćanja',
      selectMonth: 'Izaberi mesec',
      allMonths: 'Svi meseci',
      total: 'Ukupno',
      noPaymentsForMonth: 'Nema plaćanja za ovaj mesec',
      amount: 'Iznos (RSD)',
      date: 'Datum',
      method: 'Način plaćanja',
      description: 'Opis',
      descriptionPlaceholder: 'Opcionalni opis...',
      bankTransfer: 'Bankovni transfer',
      cash: 'Gotovina',
      card: 'Kartica',
      other: 'Drugo',
      addError: 'Greška pri dodavanju plaćanja',
      edit: 'Izmeni',
      delete: 'Obriši',
      editPayment: 'Izmeni plaćanje',
      deleteConfirm: 'Da li ste sigurni da želite da obrišete ovo plaćanje?',
      deleteError: 'Greška pri brisanju plaćanja',
      updateError: 'Greška pri izmeni plaćanja',
      markAsPaid: 'Označi kao plaćeno',
      markPaidError: 'Greška pri označavanju kao plaćeno',
      status: 'Status',
      pending: 'Čeka plaćanje',
      manualPayment: 'Ručno plaćanje',
      loadError: 'Istorija plaćanja nije učitana. Pokušajte ponovo.',
      retry: 'Ponovi učitavanje',
    },
    jobs: {
      title: 'Oglasi',
      create: 'Kreiraj posao',
      searchPlaceholder: 'Pretraži poslove...',
      searchBabysitters: 'Pretraga bebisiterki',
      searchJobs: 'Tražim posao',
      searchBabysittersPlaceholder: 'Pretraži bebisiterke...',
      filters: 'Filteri',
      status: 'Status',
      city: 'Grad',
      minPrice: 'Min cena (RSD)',
      maxPrice: 'Max cena (RSD)',
      minRating: 'Min ocena',
      all: 'Svi',
      allCities: 'Svi gradovi',
      posted: 'Objavljen',
      accepted: 'Prihvaćen',
      resultsCount: 'Pronađeno',
      babysitters: 'dadilja',
      jobs: 'oglasa',
      noBabysitters: 'Nema pronađenih bebisiterki',
      babysitterIn: 'Bebisiterka u',
      age: 'Godine',
      experience: 'Iskustvo',
      years: 'godina',
      avgResponseTime: 'Prosečno vreme odgovora',
      minutes: 'minuta',
      references: 'Reference',
      certificate: 'Uverenje o nekažnjavanju',
      mapNote: 'Mapa sa lokacijama - detaljna implementacija u toku',
      inProgress: 'U toku',
      completed: 'Završen',
      noJobs: 'Nema pronađenih oglasa',
      accept: 'Prihvati posao',
      acceptError: 'Greška pri prihvatanju posla',
      job: 'Posao',
      showMap: 'Prikaži mapu',
      hideMap: 'Sakrij mapu',
      mapComingSoon: 'Pregled mape uskoro. Poslovi sa lokacijama će biti prikazani ovde.',
      jobsFound: 'pronađenih oglasa',
    },
    profile: {
      title: 'Profil',
      edit: 'Izmeni profil',
      totalJobs: 'Ukupno poslova',
      earnings: 'Zarada',
      completed: 'Završeno',
      rating: 'Ocena',
      account: 'Nalog',
      friends: 'Moji prijatelji',
      editProfile: 'Izmeni profil',
      quickActions: 'Brze akcije',
      information: 'Informacije',
      role: 'Uloga',
      parent: 'Roditelj',
      babysitter: 'Bebisiterka',
      hourlyRate: 'Satnica',
      cities: 'Gradovi',
      firstName: 'Ime',
      lastName: 'Prezime',
      phone: 'Telefon',
      street: 'Ulica',
      city: 'Grad',
      postalCode: 'Poštanski broj',
      address: 'Adresa',
      messages: 'Poruke',
      updateSuccess: 'Profil je uspešno ažuriran!',
      updateError: 'Greška pri ažuriranju profila',
      uploadPhoto: 'Dodaj fotografiju',
      changePhoto: 'Promeni fotografiju',
      photoTooLarge: 'Fotografija je prevelika. Maksimalna veličina je 5MB.',
      premiumValidUntil: 'Pretplata važi do',
      premiumNoEndDate: 'Datum isteka nije dostupan.',
      cancelSubscription: 'Otkaži pretplatu',
      cancelSubscriptionConfirm: 'Da li želite da otkažete pretplatu za slanje poruka? Moći ćete ponovo da je aktivirate kasnije.',
      cancelSubscriptionSuccess: 'Pretplata je otkazana.',
      cancelSubscriptionError: 'Greška pri otkazivanju pretplate.',
      dangerZone: 'Opasna zona',
      deleteAccountTitle: 'Trajno obriši nalog',
      deleteAccountLead:
        'Ova akcija je nepovratna. Svi vaši podaci, poruke, kalendar, prijatelji i istorija biće trajno uklonjeni.',
      deleteAccountWarning:
        'Nećete moći da povratite nalog. Ako ste sigurni, unesite ispod tačan email adrese vašeg naloga i potvrdite.',
      deleteAccountEmailLabel: 'Email naloga (za potvrdu)',
      deleteAccountEmailPlaceholder: 'vas@email.com',
      deleteAccountConfirmButton: 'Obriši nalog zauvek',
      deleteAccountMismatch: 'Email se ne poklapa.',
      deleteAccountSuccess: 'Nalog je obrisan.',
      deleteAccountError: 'Brisanje naloga nije uspelo.',
      deleteAccountAdminBlocked: 'Administratorski nalog se ne može obrisati iz aplikacije.',
    },
    account: {
      title: 'Podaci naloga',
      fullName: 'Ime i prezime',
      email: 'Email',
      phone: 'Telefon',
      role: 'Uloga',
      address: 'Adresa',
      premium: 'Pretplata (poruke)',
      until: 'do',
      profile: 'Profil',
      profileComplete: 'Popunjen',
      profileIncomplete: 'Nepotpun',
      memberId: 'ID naloga',
      notSet: 'Nije uneto',
      subtitle: 'Pregled podataka vezanih za vaš nalog.',
    },
    notifications: {
      title: 'Notifikacije',
      unread: 'nepročitanih',
      noNotifications: 'Nema notifikacija',
      viewAll: 'Vidi sve',
    },
    babysitter: {
      profile: 'Profil bebisiterke',
      about: 'O meni',
      characteristics: 'Karakteristike',
      experience: 'Iskustvo',
      availability: 'Dostupnost',
      aboutMe: 'O meni',
      education: 'Obrazovanje',
      superpowers: 'Moje supermoći',
      comfortableWith: 'Komforno sa',
      references: 'Reference',
      contact: 'Kontaktiraj',
    },
    friends: {
      title: 'Prijatelji',
      addFriend: 'Dodaj prijatelja',
      loadError: 'Greška pri učitavanju prijatelja.',
      friendEmail: 'Email prijatelja',
      emailPlaceholder: 'Unesite email prijatelja',
      add: 'Dodaj',
      adding: 'Dodavanje...',
      noFriends: 'Nema povezanih prijatelja',
      connectMessage: 'Povežite se sa prijateljem da biste pratili zajednički kalendar',
      hourlyRate: 'Satnica',
      connected: 'Povezan',
      addError: 'Greška pri dodavanju prijatelja',
      removeConfirm: 'Da li ste sigurni da želite da uklonite ovog prijatelja?',
      removeError: 'Greška pri uklanjanju prijatelja',
      enterHourlyRate: 'Unesite satnicu',
      inviteSent: 'Pozivnica poslata! Prijatelj će dobiti email za prihvatanje.',
      relationshipType: 'Tip veze',
      babysitter: 'Bebisiterka',
      family: 'Porodica',
      shareCalendar: 'Podeli moj kalendar',
      calendarShared: 'Kalendar je podeljen sa prijateljem.',
      shareError: 'Greška pri deljenju kalendara',
      removed: 'Prijatelj je uklonjen.',
      addByEmail: 'Dodaj po emailu',
      addManually: 'Ručni unos',
      name: 'Naziv',
      namePlaceholder: 'Unesite ime ili naziv',
      phonePlaceholder: 'Unesite telefon',
      added: 'Prijatelj je dodat.',
      sendMessage: 'Pošalji poruku',
      noAccount: 'Prijatelj nema nalog još uvek',
      noAccountMessage: 'Prijatelj nema nalog još uvek. Ne možete slati poruke dok prijatelj ne kreira nalog.',
      noAccountShare: 'Ne možete podeliti kalendar sa prijateljem koji nema nalog.',
      notMember: 'Nije član',
      inviteToJoin: 'Pozovi prijatelja da se pridruži',
      inviteFriend: 'Pozovi prijatelja',
      inviteAsFriend: 'Pozovi kao prijatelja',
      invitingFriend: 'Slanje...',
      sharedBabysitterBadge: 'Preko deljenja',
      sharedBabysitterHint:
        'Ova dadilja je vidljiva jer vam je neko podelio kalendar. Još niste direktno povezani — pošaljite poziv da bude u vašoj listi prijatelja.',
      noEmailForInvite: 'Nema email adrese za slanje poziva.',
      inviteFriendMessage: 'Želite li da pozovete {name} da se pridruži Nannity platformi?',
      inviteFriendBenefits: 'Prijatelj će dobiti email sa pozivom koji objašnjava prednosti platforme i kako da se registruje.',
      sendInvitation: 'Pošalji poziv',
      inviteError: 'Greška pri slanju pozivnice',
      noRates: 'Nema definisanih cena. Kliknite "Dodaj" da dodate.',
      ratePeriod: 'Period',
      days: 'Dani',
      paymentSchedule: 'Dinamika plaćanja',
      dayOfMonth: 'Dan u mesecu',
      specificDay: 'Određeni dan',
      paymentDate: 'Datum',
      paymentTime: 'Vreme',
      repeatFrequency: 'Ponavljanje',
      repeatDaily: 'Svaki dan',
      repeatWeekly: 'Jednom nedeljno',
      repeatBiweekly: 'Na dve nedelje',
      repeatMonthly: 'Na mesec dana',
      paymentDays: 'Dani plaćanja',
      paymentDaysInMonth: 'Dani plaćanja u mesecu',
      paymentDaysInWeek: 'Dani plaćanja u nedelji',
      paymentDaysDescription: 'Izaberite dane u mesecu kada treba izvršiti plaćanje',
      firstDay: 'Prvi dan',
      fifteenthDay: 'polovina meseca',
      lastDay: 'poslednji dan meseca',
      paymentScheduleMenu: 'Dinamika placanja',
      workingHoursMenu: 'Radno vreme',
      editRatesMenu: 'Satnica i cene',
      setRemindersMenu: 'Postavi podsetnike',
      fullTimeWork: 'Puno radno vreme',
      enableFullTimeWork: 'Omogući automatski unos radnog vremena',
      fullTimeWorkHint: 'Automatski će se uneti radno vreme za izabrane dane nakon završetka radnog vremena',
      startTime: 'Početak',
      endTime: 'Kraj',
      workingDays: 'Radni dani',
      fillAllFields: 'Popunite sva polja',
      fullTimeWorkUpdated: 'Puno radno vreme je ažurirano',
      fullTimeWorkError: 'Greška pri ažuriranju punog radnog vremena',
      day: 'dan',
      noDaysSelected: 'Izaberite barem jedan dan za plaćanje.',
      fullName: 'Ime i prezime',
      fullNamePlaceholder: 'Unesite ime i prezime',
      editRates: 'Uredi satnicu i cene',
      flexibleRatesConfigured: 'Fleksibilne cene su podešene',
      rate: 'Cena (RSD/h)',
      everyNthDay: 'Svaki n-ti dan',
      dayNumber: 'Broj dana',
      every: 'Svaki',
      atTime: 'u',
      schedulePreview: 'Rezultat',
      everyNthWeeks: 'Svake n-te nedelje',
      everyNthWeeksHint: 'Primer: 2 = svaki drugi, 3 = svaki treći.',
      weekday: 'Dan u nedelji',
      invalidInterval: 'Unesite validan broj (n ≥ 1).',
      noWeekdaySelected: 'Izaberite dan u nedelji.',
      weekdayMondayFull: 'ponedeljak',
      weekdayTuesdayFull: 'utorak',
      weekdayWednesdayFull: 'sreda',
      weekdayThursdayFull: 'četvrtak',
      weekdayFridayFull: 'petak',
      weekdaySaturdayFull: 'subota',
      weekdaySundayFull: 'nedelja',
      saveSchedule: 'Sačuvaj dinamiku',
      changeSchedule: 'Promeni',
      scheduleType: 'Tip dinamike',
      paymentScheduleType: 'Tip dinamike plaćanja',
      monthly: 'Mesecno',
      weekly: 'Nedeljno',
      specificDays: 'Specifični dani',
      everyNth: 'Svaki n-ti dan',
      selectedDays: 'Izabrani dani',
      everyNthDescription: 'npr. ako unesete 5, plaćanje će biti svakog 5., 10., 15., 20., 25., 30. dana u mesecu',
      setPaymentSchedule: 'Postavi dinamiku plaćanja',
      scheduleUpdated: 'Dinamika plaćanja je ažurirana.',
      scheduleUpdateError: 'Greška pri ažuriranju dinamike plaćanja.',
      edit: 'Izmeni',
      delete: 'Obriši',
      moreOptions: 'Više opcija',
      editFriend: 'Izmeni prijatelja',
      friendUpdated: 'Prijatelj je ažuriran.',
      updateError: 'Greška pri ažuriranju prijatelja.',
      shareCalendarConfirm: 'Podeli sa prijateljem',
      shareCalendarConfirmMessage: 'Da li ste sigurni da želite da podelite svoj kalendar sa ovim prijateljem?',
      selectWhatToShare: 'Izaberite šta želite da podelite:',
      shareCalendarDesc: 'Podeli sve unose na kalendaru',
      sharePayments: 'Plaćanja',
      sharePaymentsDesc: 'Podeli informacije o plaćanjima',
      shareBabysitters: 'Bebisiterke',
      shareBabysittersDesc: 'Podeli veze sa bebisiterkama',
      share: 'Podeli',
      selectShareOption: 'Izaberite bar jednu opciju za deljenje.',
      removeConfirmMessage: 'Da li ste sigurni da želite da uklonite ovog prijatelja?',
      phone: 'Telefon',
      statusActive: 'Radi',
      statusInactive: 'Ne radi',
      statusNotSet: 'Status nije postavljen',
      setStatusActive: 'Postavi na "Radi"',
      setStatusInactive: 'Postavi na "Ne radi"',
      statusSetActive: 'Status je postavljen na "Radi"',
      statusSetInactive: 'Status je postavljen na "Ne radi"',
      statusUpdateError: 'Greška pri ažuriranju statusa',
    },
    conversations: {
      title: 'Poruke',
      subtitle: 'Upravljajte svojim razgovorima i porukama',
      back: 'Nazad',
      startFromFriends: 'Započnite razgovor sa stranice Prijatelji',
      noMessages: 'Još nema poruka. Započnite razgovor!',
      typeMessage: 'Unesite poruku...',
      send: 'Pošalji',
      messageSent: 'Poruka je poslata.',
      sendError: 'Greška pri slanju poruke.',
      newConversation: 'Novi razgovor',
      existingConversation: 'Postojeći razgovor',
      noFriends: 'Nema prijatelja. Dodajte prijatelje sa stranice Prijatelji.',
      addFriendsMessage: 'Dodajte prijatelje sa stranice Prijatelji da biste mogli da započnete razgovor.',
      selectFriendAbove: 'Izaberite prijatelja iznad da započnete razgovor',
      search: 'Pretraži razgovore...',
      unread: 'Nepročitano',
      inbox: 'Primljene',
      sent: 'Poslate',
      drafts: 'Nacrti',
      deleted: 'Obrisane',
      noResults: 'Nema rezultata',
      selectConversation: 'Izaberite razgovor',
      selectToRead: 'Izaberite razgovor sa liste da počnete čitanje',
      reply: 'Odgovori',
      forward: 'Prosleđi',
      delete: 'Obriši',
      more: 'Više',
      deleteConfirm: 'Da li ste sigurni da želite da obrišete ovaj razgovor?',
      deleteMessage: 'Obriši poruku',
      deleteMessageConfirm: 'Da li ste sigurni da želite da obrišete ovu poruku?',
      replyingTo: 'Odgovor na',
      typeReply: 'Unesite odgovor...',
      sendReply: 'Pošalji odgovor',
      noAccountMessage: 'Prijatelj nema nalog još uvek. Ne možete slati poruke dok prijatelj ne kreira nalog.',
      noConversations: 'Nema razgovora',
      deleteSuccess: 'Razgovor je uspešno obrisan.',
      deleteConfirmTitle: 'Potvrda brisanja',
      deleteMessageSuccess: 'Poruka je uspešno obrisana.',
      deleteMessageTitle: 'Potvrda brisanja poruke',
      selectFriend: 'Izaberite prijatelja',
      searchFriends: 'Pretraži prijatelje...',
      noFriendsFound: 'Nema pronađenih prijatelja',
      contacts: 'Kontakti',
      conversations: 'Razgovori',
      addFriends: 'Dodaj prijatelje',
      viewAll: 'Vidi sve poruke',
      archive: 'Arhiviraj',
      archiveSuccess: 'Razgovor je arhiviran.',
      noUnreadMessages: 'Nema nepročitanih poruka',
    },
    settings: {
      title: 'Podešavanja',
      subtitle: 'Profil i podešavanja naloga',
      description: 'Upravljajte podešavanjima aplikacije',
      profileDesc: 'Vaš profil i podaci',
      notificationsDesc: 'Obaveštenja i podsetnici',
      general: {
        title: 'Opšta podešavanja',
        theme: 'Tema',
        light: 'Svetla',
        dark: 'Tamna',
        system: 'Sistemska',
        language: 'Jezik',
        serbian: 'Srpski',
        english: 'English',
        currency: 'Valuta',
        currencyPlaceholder: 'Izaberite valutu',
        currencyFormat: 'Format valute',
        dateFormat: 'Format datuma',
        currencyConversion: {
          title: 'Konverzija valute',
          description: 'Menjate valutu. Unesite kurs konverzije da bi se iznosi prikazali ispravno.',
          exchangeRate: 'Kurs konverzije',
          exchangeRateHint: '1 {oldCurrency} = ? {newCurrency}',
          success: 'Valuta je uspešno promenjena',
          noRate: 'Valuta je promenjena bez konverzije iznosa',
        },
      },
      reminders: {
        title: 'Podsetnici',
        description: 'Konfigurišite podsetnike za plaćanja',
        perBabysitter: 'Podsetnici za plaćanja podešavate posebno za svaku bebisiterku: otvorite listu Bebisiterke, pa uz ime bebisiterke izaberite „Postavi podsetnike“. Podsetnici stižu na email i u aplikaciju prema tome kako podesite.',
        goToFriends: 'Idi na Bebisiterke',
      },
      version: {
        title: 'Informacije o aplikaciji',
        version: 'Verzija',
        deployed: 'Postavljeno',
      },
      notifications: {
        title: 'Podsetnici za plaćanje',
        description: 'Izaberite kada i kako želite da primate podsetnike za plaćanja.',
        emailLabel: 'Pošalji podsetnik na email',
        inAppLabel: 'Pošalji podsetnik u aplikaciji',
        reminder7d: '7 dana pre dospeća',
        reminder3d: '3 dana pre dospeća',
        reminder0d: 'Na dan dospeća',
        reminderPlus3d: '3 dana posle (ako nije plaćeno)',
        save: 'Sačuvaj podešavanja',
        saved: 'Podešavanja sačuvana',
        error: 'Nije moguće sačuvati podešavanja',
        emailDescription: 'Email podsetnici biće poslati na adresu naloga.',
        inAppDescription: 'Podsetnici će se pojaviti u obaveštenjima aplikacije.',
      },
    },
  },
  en: {
    nav: {
      login: 'Login',
      register: 'Register',
      startFree: 'Start Free',
      theme: 'Theme',
      language: 'Language',
      calendar: 'Calendar',
      payments: 'Payments',
      jobs: 'Jobs',
      profile: 'Profile',
      notifications: 'Notifications',
      friends: 'Friends',
      conversations: 'Messages',
      logout: 'Logout',
      settings: 'Settings',
      accountMenu: 'Account menu',
    },
    landing: {
      header: {
        badge: 'Babysitter Tracker',
        login: 'Log in',
        register: 'Sign up',
      },
      hero: {
        eyebrow: 'For parents and sitters',
        title: 'A trusted network for families and caregivers',
        descriptionShort: 'Find a sitter, arrange schedules, and keep track of activities in one place.',
        imageAlt: 'A parent reading with children in a bright living room',
        badgeVerified: 'Verified profile',
        register: 'Register for free',
        login: 'Login',
      },
      search: {
        findSitter: 'Looking for a sitter',
        findJob: 'Looking for a job',
        placeholder: 'Enter city or neighborhood…',
        submitSitter: 'Find a sitter',
        submitJob: 'Find a job',
      },
      trust: {
        verified: 'Verified profiles',
        reviews: 'Parent ratings',
        tracking: 'Schedule tracking',
        payment: 'Secure payments',
      },
      howItWorks: {
        title: 'How it works',
        subtitle: 'Three simple steps to trusted care.',
        step1: {
          title: 'Browse profiles',
          desc: 'Find sitters in your city and review profiles and ratings.',
          imageAlt: 'A parent browsing profiles on a phone',
        },
        step2: {
          title: 'Arrange a time',
          desc: 'Align availability and terms, then calmly arrange care.',
          imageAlt: 'A parent and child sharing a warm moment at home',
        },
        step3: {
          title: 'Track activities',
          desc: 'Keep a record of appointments and agreements in one place.',
          imageAlt: 'A caregiver drawing with a child at a table',
        },
      },
      benefits: {
        sectionTitle: 'One platform, two clear needs',
        parents: {
          title: 'For parents',
          cardTitle: 'Find someone you can trust more easily',
          description: 'Browse profiles, arrange schedules, and track activities without messages scattered everywhere.',
          imageAlt: 'Parent and child in a warm home moment',
          item1: 'Verified profiles and recommendations',
          item2: 'Simpler scheduling',
          item3: 'Activity overview in one place',
          cta: 'Find a sitter',
        },
        sitters: {
          title: 'For sitters',
          cardTitle: 'Present your experience professionally',
          description: 'Build your profile, organize engagements, and communicate more easily with families.',
          imageAlt: 'Sitter and child in a shared activity',
          item1: 'A professional profile',
          item2: 'Clear record of engagements',
          item3: 'Easier access to new jobs',
          cta: 'Register as a sitter',
        },
      },
      features: {
        title: 'Less chaos in arrangements, more clear schedules',
        subtitle: 'Nannity helps parents and sitters keep agreements, schedules, activities, and obligations organized in one place.',
        imageAlt: 'Family and sitter in a warm home setting',
        profiles: {
          title: 'Profiles and recommendations',
          description: 'Review experience, recommendations, and key details before you agree.',
        },
        schedule: {
          title: 'Schedules and activities',
          description: 'Agreed times and planned activities stay clearly organized.',
        },
        hours: {
          title: 'Hour tracking',
          description: 'Track time spent and agreed obligations more easily.',
        },
        payments: {
          title: 'Payments and reminders',
          description: 'Fewer forgotten payments and less manual calculation.',
        },
      },
      testimonials: {
        title: 'Trust is built through everyday arrangements',
        subtitle: 'Short experiences from parents and sitters who want clearer childcare organization.',
        t1: {
          name: 'Marko P.',
          role: 'parent',
          text: 'What matters most is that I do not hunt for schedules, agreements, and activities in messages—I have everything in one place.',
        },
        t2: {
          name: 'Jovana S.',
          role: 'parent',
          text: 'It is easier to track what was agreed for each session and keep a clearer view of obligations.',
        },
        t3: {
          name: 'Ana M.',
          role: 'sitter',
          text: 'My profile helps me present my experience to families more professionally.',
        },
      },

      pricing: {
        title: 'Pricing and Plans',
        description: 'Choose the plan that suits you best. All plans include basic features.',
        free: 'Free',
        basic: 'Basic',
        premium: 'Premium',
        month: 'RSD/month',
        mostPopular: 'Most Popular',
        select: 'Select',
      },
      cta: {
        title: 'Ready to get started?',
        description: 'Join parents and sitters who use Nannity to organize childcare more easily.',
      },
      faq: {
        title: 'Frequently Asked Questions',
        q1: 'How does Nannity work?',
        a1: 'Nannity is a platform that connects parents and babysitters. Parents can track work hours, automatically calculate payments, and manage their calendar. Babysitters can track their jobs, earnings, and receive notifications about new opportunities.',
        q2: 'Is the platform free?',
        a2: 'Yes, there is a free plan with basic features. We also have a Basic plan (599 RSD/month) and Premium plan (899 RSD/month) with additional features.',
        q3: 'How does automatic payment work?',
        a3: 'You can set up a payment schedule (monthly, weekly, or on specific days). The platform automatically calculates the amount based on work hours and hourly rate, and you receive reminders before the payment date.',
        q5: 'Can I share my calendar with family?',
        a5: 'Yes! You can share your calendar, payments, and babysitter connections with family members. Just select what you want to share when sharing your calendar with a friend.',
        q6: 'How do I get started?',
        a6: 'Simply register for free, complete your profile, and start using the platform. You can immediately add a babysitter or start looking for a job as a babysitter.',
      },
    },
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      close: 'Close',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      back: 'Back',
      yes: 'Yes',
      no: 'No',
      confirm: 'Confirm',
    },
    auth: {
      logoutConfirmTitle: 'Logout Confirmation',
      logoutConfirmMessage: 'Are you sure you want to logout?',
      logout: 'Logout',
      login: {
        title: 'Login',
        subtitle: {
          choose: 'Choose login method',
          email: 'Enter your email address',
          otp: 'Enter OTP code from your email',
        },
        emailButton: 'Login with email',
        googleButton: 'Login with Google',
        or: 'Or',
        otherMethods: 'Other login methods',
        continueWithOTP: 'Continue with one-time code',
        emailLabel: 'Email address',
        emailPlaceholder: 'your@email.com',
        sendLink: 'Send link to email',
        sending: 'Sending...',
        sendOTP: 'Send one-time code',
        sendingOTP: 'Sending OTP code...',
        otpLabel: 'OTP code',
        otpPlaceholder: '123456',
        otpSentTo: 'Code sent to:',
        verifyOTP: 'Verify OTP code',
        verifying: 'Verifying...',
        backToEmail: 'Back to email',
        noAccount: "Don't have an account? Register",
        checkEmail: 'Check your email for login link!',
        loginSuccess: 'Successfully logged in!',
        googleNotConfigured: 'Google Sign In is not configured. Please use email link to login.',
        googleNotAvailable: 'Google Sign In is not available on this browser. Please use email link.',
        googleRequiresHTTPS: 'Google Sign In requires HTTPS. Please use email link to login.',
        googleError: 'Google Sign In error',
        enterEmail: 'Please enter email address',
        enterValidOTP: 'Please enter a valid 6-digit code',
        otpSent: 'OTP code has been sent to your email address',
        otpError: 'Error sending OTP code',
        verifyError: 'Error verifying OTP code',
        linkError: 'Error sending link',
        unknownError: 'Unknown error. Please try again.',
        invalidLink: 'Invalid or expired login link.',
        verificationError: 'Verification error. Please try again.',
        invalidLinkRetry: 'Invalid login link. Please try again.',
        passwordLabel: 'Password',
        passwordPlaceholder: '••••••••',
        signIn: 'Sign in',
        loggingIn: 'Signing in...',
        invalidCredentials: 'Invalid email or password',
        withPassword: 'Sign in with email and password',
        withOTP: 'Sign in without password (code to email)',
        withLink: 'Sign in via email link',
        enterEmailAndPassword: 'Enter email and password',
        switchToLink: 'Sign in via email link',
        invalidLinkCheckEmail: 'Invalid login link. Please check your email again.',
        processingError: 'Error processing login link. Please try again.',
        redirecting: 'Successfully logged in! Redirecting...',
        redirectingError: 'Login error. Redirecting to login...',
      },
      register: {
        step: 'Step',
        of: 'of',
        back: 'Back',
        next: 'Next',
        role: {
          title: 'Choose your role',
          parent: {
            title: 'Parent / Guardian',
            description: 'Looking for a babysitter for your child',
          },
          babysitter: {
            title: 'Babysitter',
            description: 'Looking for a job as a babysitter',
          },
        },
        seeking: {
          title: 'Are you looking for a babysitter?',
          description: 'Choose an option below',
          yes: 'Yes, I am looking for a babysitter',
          no: 'No, I only use the app for tracking',
        },
        jobSearch: {
          title: 'Are you looking for a job?',
          fullTime: 'Looking for a job (full-time)',
          additional: 'Looking for additional job',
          notLooking: 'Not looking for a job currently',
        },
        city: {
          titleProvider: 'In which cities do you work?',
          titleParent: 'In which cities are you looking for a babysitter?',
          descriptionProvider: 'You can select cities where you want to work',
          descriptionParent: 'You can select cities where you are looking for a babysitter',
          addPlaceholder: 'Add another city...',
          addButton: 'Add +',
          alreadyAdded: 'City is already added',
          enterCity: 'Please enter city name',
          selectAtLeastOne: 'Please select at least one city',
        },
        childYear: {
          title: 'Child birth year',
          description: 'Select child birth year',
          select: 'Select year...',
        },
        hourly: {
          title: 'Your hourly rate',
          description: 'Enter your hourly rate in RSD',
          min: 'Min (RSD)',
          max: 'Max (RSD)',
          minPlaceholder: '500',
          maxPlaceholder: '1000',
        },
        name: {
          title: 'First and last name',
          description: 'Enter your first and last name',
          firstName: 'Your first name',
          lastName: 'Your last name',
        },
        email: {
          title: 'Email and phone',
          description: 'Enter email and phone number',
          emailPlaceholder: 'Email address',
          phonePlaceholder: 'Phone number',
        },
        submit: {
          sending: 'Sending...',
          register: 'Register',
        },
        googleSignUp: 'Register with Google',
        googleComingSoon: 'Register in seconds using your Google account.',
        alreadyHaveAccount: 'Already have an account? Login',
        signInLink: 'Login',
        checkEmail: 'Check your email for registration link!',
        selectRole: 'Please select a role',
        selectJobStatus: 'Please select job search status',
      },
      completeProfile: {
        title: 'Complete your profile',
        subtitle: 'Please provide the basic information so we can personalise your experience and enable bookings.',
        firstName: 'First name',
        lastName: 'Last name',
        phone: 'Phone number',
        role: 'Role',
        roleParent: 'Parent / Guardian',
        roleBabysitter: 'Babysitter',
        hourlyRate: 'Hourly rate (RSD)',
        street: 'Street & number',
        streetPlaceholder: 'Example street 12',
        city: 'City',
        cityPlaceholder: 'Belgrade',
        postalCode: 'Postal code',
        postalPlaceholder: '11000',
        info: 'These details are required so parents and babysitters can send you offers and bookings.',
        save: 'Save profile',
        saving: 'Saving...',
        success: 'Profile updated successfully!',
        error: 'Unable to save profile. Please try again.',
        validationError: 'Please complete all required fields.',
        sessionExpired: 'Session expired. Please login again.',
        photoError: 'Error processing image',
        photoTooLarge: 'Photo is too large. Maximum size is 5MB.',
      },
    },
    calendar: {
      title: 'Calendar',
      currentDebt: 'Current Debt',
      monthJobs: 'This Month Jobs',
      totalHours: 'Total Hours',
      jobsForDate: 'Jobs for',
      job: 'Job',
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
      sunday: 'Sun',
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat',
      addEntry: 'Add Entry',
      edit: 'Edit',
      delete: 'Delete',
      deleteConfirm: 'Are you sure you want to delete this entry?',
      saveAndAddAnother: 'Save and Add Another',
      subtitle: 'Manage your shifts and hours',
      manageSchedule: 'Organise the work schedule in a few clicks',
      selectedDay: 'Selected Day',
      addTimeSlot: 'Enter Time Slot',
      noEntriesDay: 'No entries for this day',
      timeSlots: 'time slots',
      monthOverview: 'Month Overview',
      overlapError: 'This time range overlaps with an existing entry.',
      invalidRange: 'Start time must be before end time.',
      paid: 'Paid',
      unpaid: 'Unpaid',
      emptyEntry: 'Empty entry',
      partiallyPaid: 'Partially paid',
      totalDebt: 'Total Debt',
      noPreviousDebt: 'No previous debt',
      nextPayment: 'Next Payment',
      day: 'day',
      today: 'Today',
      noSchedule: 'Not set',
      setupPayment: 'Setup Payment',
      selectBabysitter: 'Select babysitter',
      sharedWith: 'Calendar shared with',
      sharedWithShort: 'Shared with',
      sharedBy: 'Shared by',
      calendarView: 'Calendar',
      listView: 'List',
      viewMode: 'Calendar view',
      calendarActions: 'Calendar actions',
      updateError: 'Error updating entry',
      createError: 'Error creating entry',
      deleteError: 'Error deleting entry',
      manageBabysitters: 'Manage babysitters',
      setPaymentDate: 'Set Payment Date',
      paymentDate: 'Payment Date',
      paymentDateHint: 'Leave empty to remove manually set payment date.',
      paymentDateRequired: 'Please enter payment date.',
      paymentDateSet: 'Payment date has been set.',
      paymentDateError: 'Error setting payment date.',
      paymentDateRemoved: 'Payment date has been removed.',
      removePaymentDate: 'Remove Payment Date',
      manualPaymentDate: 'Manual Payment Date',
      paymentTime: 'Payment Time',
      paymentTimeHint: 'Default reminder time is 14:00',
      markAsPaid: 'Mark as Paid',
      recordPaymentUpToDate: 'Record payment (all debt up to this date)',
      recordPaymentModalTitle: 'Record payment',
      markDayRowAsPaid: 'Mark this day as paid',
      markDayRowAsUnpaid: 'Mark this day as unpaid',
      markDayRowAsPaidShort: 'Paid',
      markDayRowAsUnpaidShort: 'Unpaid',
      editingSharedCalendarHint: 'You are editing a shared calendar (you have write access).',
      history: 'History',
      someone: 'Someone',
      auditEntryCreated: 'Entry created',
      auditEntryUpdated: 'Entry updated',
      auditEntryDeleted: 'Entry deleted',
      auditEntryMarkedPaid: 'Day marked as paid',
      auditEntryMarkedUnpaid: 'Day marked as unpaid',
      auditPaymentDateSet: 'Payment date set',
      auditPaymentDateRemoved: 'Payment date removed',
      auditUnknown: 'Change',
      markAsPaidConfirm: 'Mark the day as paid and create a payment record.',
      markAsPaidHint: 'Amount includes all unpaid entries up to this date (including earlier months). You can modify it.',
      confirmMarkAsPaid: 'Confirm and Mark as Paid',
      paymentMarkedAsPaid: 'Payment marked as paid and record created.',
      invalidAmount: 'Please enter a valid amount.',
      amount: 'Amount (RSD)',
      amountHint: 'Suggested amount based on entries up to payment date',
      autoFillOptions: 'Auto-fill Calendar',
      autoFillToToday: 'Fill up to today',
      autoFillToSelected: 'Fill up to selected date',
      autoFillToSelectedSuccess: 'Created {count} entries up to selected date.',
      autoFillMonth: 'Fill entire month',
      autoFillSuccess: 'Created {count} entries up to today.',
      autoFillMonthSuccess: 'Created {count} entries for entire month.',
      autoFillError: 'Error auto-filling calendar',
      deleteAllMonth: 'Remove all times for this month',
      deleteAllMonthConfirm: 'Are you sure you want to delete all times for this month?',
      deleteAllMonthSuccess: 'Deleted {count} entries for this month.',
      deleteAllMonthError: 'Error deleting entries',
      deleteAllMonthConfirmTitle: 'Confirm deletion',
      totalHoursThisMonth: 'Total hours this month',
      unpaidHoursThisMonth: 'Unpaid for this month',
      markAllPaidToToday: 'Mark all as paid up to today',
      markAllPaidToTodaySuccess: 'Marked {count} entries as paid up to today.',
      markAllPaidToSelected: 'Mark all as paid up to this date',
      markAllPaidToSelectedSuccess: 'Marked {count} entries as paid up to this date.',
      markAllPaidMonth: 'Mark all as paid for month',
      markAllPaidMonthSuccess: 'Marked {count} entries as paid for month.',
      markAllPaidError: 'Error marking as paid',
      setPaymentDates: 'Set payment dates according to schedule',
      setPaymentDatesSuccess: 'Set {count} payment dates according to schedule.',
      setPaymentDatesError: 'Error setting payment dates',
      noPaymentSchedule: 'No payment schedule set for babysitter.',
    },
    payments: {
      title: 'Payments',
      currentCharge: 'Current Charge',
      nextPayDay: 'Next Pay Day',
      manualPayDay: 'Manually set payment date',
      inDays: 'in',
      days: 'days',
      previousPayments: 'Previous Payments',
      noPayments: 'No previous payments',
      payment: 'Payment',
      paid: 'Paid',
      paymentPeriod: 'Payment Period',
      periodStart: 'Start Date',
      periodEnd: 'End Date',
      unpaidPeriod: 'Unpaid period',
      unpaidPeriods: 'Unpaid:',
      toBabysitter: 'To',
      noBabysitter: 'You don\'t have a babysitter added. Add a babysitter from the Friends page.',
      noPaymentSchedule: 'Payment schedule is not set. Set up payment schedule for your babysitter.',
      manualPayment: 'Manual payment',
      allMonths: 'All months',
      loadError: 'Payment history could not be loaded. Please try again.',
      retry: 'Retry',
    },
    jobs: {
      title: 'Jobs',
      create: 'Create Job',
      searchPlaceholder: 'Search jobs...',
      filters: 'Filters',
      status: 'Status',
      city: 'City',
      minPrice: 'Min Price (RSD)',
      maxPrice: 'Max Price (RSD)',
      all: 'All',
      allCities: 'All Cities',
      posted: 'Posted',
      accepted: 'Accepted',
      inProgress: 'In Progress',
      completed: 'Completed',
      noJobs: 'No jobs found',
      accept: 'Accept Job',
      acceptError: 'Error accepting job',
      job: 'Job',
      showMap: 'Show Map',
      hideMap: 'Hide Map',
      mapComingSoon: 'Map view coming soon. Jobs with locations will be displayed here.',
      jobsFound: 'jobs found',
    },
    profile: {
      title: 'Profile',
      edit: 'Edit Profile',
      totalJobs: 'Total Jobs',
      earnings: 'Earnings',
      completed: 'Completed',
      rating: 'Rating',
      account: 'Account',
      friends: 'My Friends',
      editProfile: 'Edit Profile',
      quickActions: 'Quick Actions',
      information: 'Information',
      role: 'Role',
      parent: 'Parent',
      babysitter: 'Babysitter',
      hourlyRate: 'Hourly Rate',
      cities: 'Cities',
      address: 'Address',
      messages: 'Messages',
      premiumValidUntil: 'Subscription valid until',
      premiumNoEndDate: 'End date not available.',
      cancelSubscription: 'Cancel subscription',
      cancelSubscriptionConfirm:
        'Cancel your messaging subscription? You can activate it again later.',
      cancelSubscriptionSuccess: 'Subscription cancelled.',
      cancelSubscriptionError: 'Could not cancel subscription.',
      dangerZone: 'Danger zone',
      deleteAccountTitle: 'Permanently delete account',
      deleteAccountLead:
        'This cannot be undone. All your data, messages, calendar, friends and history will be permanently removed.',
      deleteAccountWarning:
        'You will not be able to recover your account. If you are sure, type your account email below and confirm.',
      deleteAccountEmailLabel: 'Account email (confirmation)',
      deleteAccountEmailPlaceholder: 'you@email.com',
      deleteAccountConfirmButton: 'Delete account forever',
      deleteAccountMismatch: 'Email does not match.',
      deleteAccountSuccess: 'Account deleted.',
      deleteAccountError: 'Could not delete account.',
      deleteAccountAdminBlocked: 'Administrator accounts cannot be deleted from the app.',
    },
    account: {
      title: 'Account details',
      fullName: 'Full name',
      email: 'Email',
      phone: 'Phone',
      role: 'Role',
      address: 'Address',
      premium: 'Messaging subscription',
      until: 'until',
      profile: 'Profile',
      profileComplete: 'Complete',
      profileIncomplete: 'Incomplete',
      memberId: 'Account ID',
      notSet: 'Not set',
      subtitle: 'Overview of data linked to your account.',
    },
    notifications: {
      title: 'Notifications',
      unread: 'unread',
      noNotifications: 'No notifications',
      viewAll: 'View all',
    },
    babysitter: {
      profile: 'Babysitter Profile',
      about: 'About',
      characteristics: 'Characteristics',
      age: 'Age',
      experience: 'Experience',
      availability: 'Availability',
      aboutMe: 'About Me',
      education: 'Education',
      superpowers: 'My babysitting superpowers',
      comfortableWith: 'Comfortable with',
      references: 'References',
      contact: 'Contact',
    },
    friends: {
      title: 'Friends',
      addFriend: 'Add Friend',
      loadError: 'Error loading friends.',
      friendEmail: 'Friend Email',
      emailPlaceholder: 'Enter friend email',
      add: 'Add',
      adding: 'Adding...',
      noFriends: 'No friends connected',
      connectMessage: 'Connect with friends to share calendar and track together',
      hourlyRate: 'Hourly Rate',
      connected: 'Connected',
      addError: 'Error adding friend',
      removeConfirm: 'Are you sure you want to remove this friend?',
      removeError: 'Error removing friend',
      enterHourlyRate: 'Enter hourly rate',
      inviteSent: 'Invitation sent! Your friend will receive an email to accept.',
      paymentSchedule: 'Payment Schedule',
      dayOfMonth: 'Day of month',
      repeatFrequency: 'Repeat frequency',
      repeatDaily: 'Every day',
      repeatWeekly: 'Once a week',
      repeatBiweekly: 'Bi-weekly',
      repeatMonthly: 'Monthly',
      paymentDays: 'Payment days',
      paymentDaysInMonth: 'Payment days in month',
      paymentDaysInWeek: 'Payment days in week',
      paymentDaysDescription: 'Select days in the month when payment should be made',
      firstDay: 'First day',
      fifteenthDay: 'Mid-month',
      lastDay: 'Last day',
      day: 'day',
      noDaysSelected: 'Please select at least one day for payment.',
      everyNthDay: 'Every nth day',
      dayNumber: 'Day number',
      every: 'Every',
      atTime: 'at',
      schedulePreview: 'Result',
      everyNthWeeks: 'Every N weeks',
      everyNthWeeksHint: 'Example: 2 = every other, 3 = every third.',
      weekday: 'Weekday',
      invalidInterval: 'Enter a valid number (n ≥ 1).',
      noWeekdaySelected: 'Select a weekday.',
      weekdayMondayFull: 'Monday',
      weekdayTuesdayFull: 'Tuesday',
      weekdayWednesdayFull: 'Wednesday',
      weekdayThursdayFull: 'Thursday',
      weekdayFridayFull: 'Friday',
      weekdaySaturdayFull: 'Saturday',
      weekdaySundayFull: 'Sunday',
      saveSchedule: 'Save schedule',
      changeSchedule: 'Change',
      scheduleType: 'Schedule type',
      paymentScheduleType: 'Payment schedule type',
      monthly: 'Monthly',
      weekly: 'Weekly',
      specificDays: 'Specific days',
      everyNth: 'Every nth day',
      selectedDays: 'Selected days',
      everyNthDescription: 'e.g. if you enter 5, payment will be on 5th, 10th, 15th, 20th, 25th, 30th day of the month',
      setPaymentSchedule: 'Set payment schedule',
      scheduleUpdated: 'Payment schedule updated.',
      scheduleUpdateError: 'Error updating payment schedule.',
      edit: 'Edit',
      delete: 'Delete',
      moreOptions: 'More options',
      editFriend: 'Edit friend',
      friendUpdated: 'Friend updated.',
      updateError: 'Error updating friend.',
      noAccount: 'Friend does not have an account yet',
      noAccountMessage: 'Friend does not have an account yet. You cannot send messages until the friend creates an account.',
      noAccountShare: 'You cannot share calendar with a friend who does not have an account.',
      notMember: 'Not a member',
      inviteToJoin: 'Invite friend to join',
      inviteFriend: 'Invite Friend',
      inviteAsFriend: 'Invite as friend',
      invitingFriend: 'Sending...',
      sharedBabysitterBadge: 'Via sharing',
      sharedBabysitterHint:
        'This babysitter is visible because someone shared their calendar with you. You are not connected directly yet — send an invite to add them to your friends list.',
      noEmailForInvite: 'No email address available to send an invite.',
      inviteFriendMessage: 'Do you want to invite {name} to join the Nannity platform?',
      inviteFriendBenefits: 'The friend will receive an email invitation explaining the platform benefits and how to register.',
      sendInvitation: 'Send Invitation',
      inviteError: 'Error sending invitation',
      shareCalendarConfirm: 'Share with friend',
      shareCalendarConfirmMessage: 'Are you sure you want to share your calendar with this friend?',
      selectWhatToShare: 'Select what you want to share:',
      shareCalendar: 'Calendar',
      shareCalendarDesc: 'Share all calendar entries',
      sharePayments: 'Payments',
      sharePaymentsDesc: 'Share payment information',
      shareBabysitters: 'Babysitters',
      shareBabysittersDesc: 'Share babysitter connections',
      share: 'Share',
      selectShareOption: 'Please select at least one option to share.',
      removeConfirmMessage: 'Are you sure you want to remove this friend?',
      phone: 'Phone',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      statusNotSet: 'Status not set',
      setStatusActive: 'Set to "Active"',
      setStatusInactive: 'Set to "Inactive"',
      statusSetActive: 'Status set to "Active"',
      statusSetInactive: 'Status set to "Inactive"',
      statusUpdateError: 'Error updating status',
    },
    conversations: {
      title: 'Messages',
      back: 'Back',
      noConversations: 'No conversations yet',
      startFromFriends: 'Start a conversation from the Friends page',
      noMessages: 'No messages yet. Start a conversation!',
      typeMessage: 'Type a message...',
      send: 'Send',
      newConversation: 'New conversation',
      existingConversation: 'Existing conversation',
      noFriends: 'No friends. Add friends from the Friends page.',
      addFriendsMessage: 'Add friends from the Friends page to start a conversation.',
      selectFriendAbove: 'Select a friend above to start a conversation',
      search: 'Search conversations...',
      unread: 'Unread',
      inbox: 'Inbox',
      sent: 'Sent',
      drafts: 'Drafts',
      deleted: 'Deleted',
      noResults: 'No results',
      selectConversation: 'Select a conversation',
      selectToRead: 'Select a conversation from the list to start reading',
      reply: 'Reply',
      forward: 'Forward',
      delete: 'Delete',
      more: 'More',
      deleteConfirm: 'Are you sure you want to delete this conversation?',
      deleteMessage: 'Delete message',
      deleteMessageConfirm: 'Are you sure you want to delete this message?',
      replyingTo: 'Replying to',
      typeReply: 'Type a reply...',
      noAccountMessage: 'Friend does not have an account yet. You cannot send messages until the friend creates an account.',
      sendReply: 'Send reply',
      deleteSuccess: 'Conversation deleted successfully',
      deleteConfirmTitle: 'Confirm deletion',
      deleteMessageSuccess: 'Message deleted successfully',
      deleteMessageTitle: 'Confirm message deletion',
      selectFriend: 'Select friend',
      searchFriends: 'Search friends...',
      noFriendsFound: 'No friends found',
      contacts: 'Contacts',
      conversations: 'Conversations',
      addFriends: 'Add friends',
      viewAll: 'View all messages',
      archive: 'Archive',
      archiveSuccess: 'Conversation archived.',
      noUnreadMessages: 'No unread messages',
    },
    settings: {
      title: 'Settings',
      subtitle: 'Profile and account settings',
      description: 'Manage your application settings',
      profileDesc: 'Your profile and data',
      notificationsDesc: 'Notifications and reminders',
      general: {
        title: 'General Settings',
        theme: 'Theme',
        language: 'Language',
        light: 'Light',
        dark: 'Dark',
        system: 'System',
        serbian: 'Serbian',
        english: 'English',
        currency: 'Currency',
        currencyFormat: 'Currency Format',
        dateFormat: 'Date Format',
        currencyPlaceholder: 'Select currency',
        currencyConversion: {
          title: 'Currency Conversion',
          description: 'You are changing the currency. Enter the exchange rate so amounts are displayed correctly.',
          exchangeRate: 'Exchange Rate',
          exchangeRateHint: '1 {oldCurrency} = ? {newCurrency}',
          success: 'Currency changed successfully',
          noRate: 'Currency changed without amount conversion',
        },
      },
      reminders: {
        title: 'Reminders',
        description: 'Configure payment reminders',
        perBabysitter: 'Payment reminders are configured per babysitter: open the Babysitters list and choose "Set reminders" next to each name. Reminders are sent by email and in-app as configured.',
        goToFriends: 'Go to Babysitters',
      },
      version: {
        title: 'Application Information',
        version: 'Version',
        deployed: 'Deployed',
      },
      notifications: {
        title: 'Payment reminders',
        description: 'Choose when and how you want to receive payment reminders.',
        emailLabel: 'Send reminder via email',
        inAppLabel: 'Send reminder in the app',
        reminder7d: '7 days before due date',
        reminder3d: '3 days before due date',
        reminder0d: 'On the due date',
        reminderPlus3d: '3 days after (if unpaid)',
        save: 'Save settings',
        saved: 'Reminder settings saved',
        error: 'Unable to save reminder settings',
        emailDescription: 'Email reminders will be sent to your account address.',
        inAppDescription: 'Reminders will appear in app notifications.',
      },
    },
  },
};

// Get current language from localStorage or default to 'sr'
const getLanguage = () => {
  return localStorage.getItem('language') || 'sr';
};

// Set language
const setLanguage = (lang) => {
  localStorage.setItem('language', lang);
  // Trigger custom event for components to update
  window.dispatchEvent(new CustomEvent('languageChanged', { detail: { language: lang } }));
};

// Translate function
// IMPORTANT: returns '' (empty string) when key is missing so call-sites like `t(key) || fallback`
// can properly fall back without showing raw i18n keys to end users.
const t = (key, lang = null) => {
  const currentLang = lang || getLanguage();
  const keys = key.split('.');
  let value = translations[currentLang];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      // Missing translation: don't leak raw key to UI
      if (import.meta?.env?.DEV) {
        console.warn(`Translation key not found: ${key} for language: ${currentLang}`);
      }
      return '';
    }
  }
  
  if (value === undefined || value === null || value === '') {
    if (import.meta?.env?.DEV) {
      console.warn(`Translation key not found/empty: ${key} for language: ${currentLang}`);
    }
    return '';
  }

  return value;
};

export { t, getLanguage, setLanguage, translations };
